import { useEffect, useState } from "react";
import Pagination from "../../components/Table/pagination";
import useAuth from "../../hooks/useAuth";

import { useNavigate, useLocation } from "react-router-dom";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
import Popup from "reactjs-popup";
import CallFeedback from "../../components/Feedbacks/Feedback";
import axios from "axios";
// import axios from "../../utils/axios";
import { ReactComponent as Outgoing } from "../../assets/icons/outgoingcall.svg";

// PDF DOWNLOAD //
import jsPDF from "jspdf";
import "jspdf-autotable";

// EXCEL DOWNLOAD //
import * as XLSX from "xlsx"; // Import all exports from 'xlsx'

import { ReactComponent as Pdf } from "../../assets/icons/pdf-file-svgrepo-com.svg";
import { ReactComponent as Excel } from "../../assets/icons/excel-svgrepo-com.svg";
import { BarChart3 } from "lucide-react";
import CallBackFeedback from "../../Popups/callBackFeedback";

function CallBackReport(props) {
    const [camplist, setCampList] = useState([]);
    const axiosPrivate = UseAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();

    const BASE_URL = process.env.REACT_APP_API_URL;

    const { auth } = useAuth();

    const [fback, setfback] = useState(false);

    const [callBackReportData, setCallBackReportData] = useState([]);

    const [showDescendants, setShowDescendants] = useState(false);

    const [campaign, setCampaign] = useState("");

    const [status, setStatus] = useState("");

    const [filterData, setFilerData] = useState("")

    /// Fro Date ///
    const [fromDate, setFromDate] = useState("");
    /// To Date ///
    const [toDate, setToDate] = useState("");

    // -------------------------------- PAGINATION -------------------------------- //
    const Initial_pagination = {
        next: "",
        previous: "",
        count: "",
        total_pages: "",
        current_page: 1,
        page_size: 5,
        current_page_count: 0 
    };

    const [pagination, setPagination] = useState(Initial_pagination);

    const PaginationControl = (type, number) => {
        if (type == "page") {
            if (number <= pagination.total_pages) {
                fetchCallBackReport(number);
            } else {
                fetchCallBackReport(1);
            }
        } else if (type == "last") {
            fetchCallBackReport(pagination.total_pages);
        } else if (type == "prev") {
            if (pagination.current_page > 1) {
                fetchCallBackReport(pagination.current_page - 1);
            }
        } else if (type == "next") {
            if (pagination.current_page < pagination.total_pages) {
                fetchCallBackReport(pagination.current_page + 1);
            }
        } else {
            fetchCallBackReport(1);
        }
    };

    //  SEARCH //
    const [searchData, setSearchData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [userType, setUserType] = useState("");

    useEffect(() => {
        fetchCallBackReport(1)
    }, [])


    const fetchCallBackReport = async (pagenumber) => {
        let post_data;
        if (auth?.user_details?.type === "agent") {
            post_data = {
                user_id: auth?.user_details?.id,
                user_type: auth?.user_details?.type,
                download: "yes",
                campaign: campaign || "",
                input_text: searchText,
                status: status,
                filter_data: filterData,
                page: pagenumber,
                from: fromDate || "",
                to: toDate || "",
                user_status: userType || "",
                show_descendants: showDescendants,
            };
        } else {
            post_data = {
                user_id: auth?.user_details?.id,
                user_type: auth?.user_details?.type,
                download: "yes",
                campaign: campaign || "",
                input_text: searchText,
                status: status,
                filter_data: filterData,
                page: pagenumber,
                from: fromDate || "",
                to: toDate || "",
                user_status: userType || "",
            };
        }
        let isMounted = true;
        const controller = new AbortController();

        try {
            const response = await axiosPrivate.post(
                process.env.REACT_APP_API_URL + "/contactcentre/callback_report/",
                post_data,
                {
                    signal: controller.signal,
                }
            );
            setCallBackReportData(response.data.results);
            setPagination((prevState) => {
                return {
                    ...prevState,
                    total_pages: response.data?.total_pages || 0,
                    previous: response.data?.previous || null,
                    next: response.data?.next || null,
                    current_page: response.data?.current_page || 0,
                    count: response.data?.count || 0,
                    page_size: response.data?.page_size || 5,
                    current_page_count: response.data?.results?.length || 0 
                };
            });
        } catch (err) {
            console.error(err);
            navigate("/login", { state: { from: location }, replace: true });
        }
    };

    const fetchcampaignList = async () => {
        let post_data;
        console.log("user details   :   ", auth?.user_details)
        if (auth?.user_details?.type === "agent") {
            post_data = {
                user_id: auth?.user_details?.user,
                user_type: auth?.user_details?.type,
                download: "yes",
                campaign: campaign || "",
                input_text: searchText,
                show_descendants: showDescendants,
            };
        } else {
            post_data = {
                user_id: auth?.user_details?.user,
                user_type: auth?.user_details?.type,
                download: "yes",
                campaign: campaign || "",
                input_text: searchText,
            };
        }
        let isMounted = true;
        const controller = new AbortController();

        try {
            const response = await axiosPrivate.get(
                process.env.REACT_APP_API_URL + "/contactcentre/all-campaigns/",
                {
                    signal: controller.signal,
                    params: post_data,
                }
            );

            isMounted && setCampList(response.data);
            // fetchCallBackReport();
        } catch (err) {
            console.error(err);
            navigate("/login", { state: { from: location }, replace: true });
        }
    };

    useEffect(() => {
        fetchcampaignList();
    }, []);


    const FetchData = () => {
        fetchCallBackReport(1);
    };


    // Download Voice File //
    const DownloadRecord = async (vffile, date, id) => {
        let obj = {
            url: vffile,
            date: date,
        };

        let config = {
            headers: { "Content-Type": "application/json" },
        };

        let CALL_RECORD_URL = "/callrecordfile/";

        try {
            const response = await axios.post(
                BASE_URL + CALL_RECORD_URL,
                obj,
                config
            );

            if (response?.data?.status == 1) {
                // Download succeeded, now fetch campaign report data
                fetchCallBackReport(pagination.current_page);
                const report_data = callBackReportData.map((item) => {
                    if (item.voice_file === vffile) {
                        const audioElement = document.getElementById(item.voice_file);
                        audioElement.load();
                    }
                });
            }
        } catch (err) {
            console.log(err);
        }
    };

    // -------   Download Data  -------- //

    const [downloadData, setDownloadData] = useState([]);

    const downloadSheet = async (type) => {
        try {
            const response = fetchCallBackReport(0)
            console.log("========response data", response);
            const response_data = response.data;
            try {
                if (type == "PDF") {
                    downloadpdfData(callBackReportData);
                } else {
                    downloadxcelData(callBackReportData);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const downloadpdfData = (dataset) => {
        try {
            // Use the updated downloadData
            // Create a new jsPDF instance
            const doc = new jsPDF();
            // Add content to the PDF
            doc.text("Callback Report", 10, 10);
            console.log(dataset,"----------------------")
            // Extract table data and format it
            const tableData = dataset.flatMap((campaign_obj, index) => {
                return [
                    [index < 9 ? `0${index + 1}` : `${index + 1}`, 'Campaign', campaign_obj.name],
                    ['', 'Customer', `${campaign_obj.customer_name} (${campaign_obj.legbDestinationNumber})`],
                    ['', 'Agent', campaign_obj.agent_username],
                    ['', 'Campaign', campaign_obj.name],
                    ['', 'Call Status', campaign_obj.callStatus],
                    ['', 'Call Time', campaign_obj.legastarttime],
                    ['', '', ''], // Empty row for spacing between entries
                ];
            });

            // // AutoTable plugin to generate the table
            doc.autoTable({
                head: [['S.No', 'Head', 'Data']], // Table headers
                body: tableData,                 // Data with serial number, key, and value
                startY: 20,                      // Adjust starting Y position
                styles: {
                    cellPadding: 1,                // Add padding for better readability
                    fontSize: 10,                  // Adjust font size
                },
                columnStyles: {
                    0: { cellWidth: 20 },          // Width for the serial number column
                    1: { cellWidth: 50 },          // Width for the key column
                    2: { cellWidth: 110 },         // Width for the value column
                },
            });


            // Save or open the PDF
            doc.save("CallBackReport.pdf");
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const downloadxcelData = (dataset) => {
        // Define the fields to exclude
        const excludedFields = [
            "legaStartTime",
            "asteriskEventId",
            "destinationType",
            "callEndTime",
            "callBackParentID",
            "autocallrecord_id",
            "callrecord_id",
            "campaign_customer_id",
            "useragent_id",
            "vsip_id",
            "user_id"
        ];

        // Create a new array with the desired fields only
        const filteredData = dataset.map((item) => {
            const filteredItem = { ...item };
            excludedFields.forEach((field) => {
                delete filteredItem[field];
            });
            return filteredItem;
        });

        const excelData = [];

        filteredData.forEach((item) => {
            const data = {};
            data["Campaign"] = item["name"];
            data["Customer Name"] = item["customer_name"];
            data["Customer Number"] = item["legbDestinationNumber"];
            data["Agent Name"] = item["agent_username"];
            data["Agent Number"] = item["legaDestinationName"];
            data["Call Start Time"] = item["legastarttime"];
            data["CallStatus"] = item["callStatus"];
            console.log("CAMPAIN", campaign);
            excelData.push(data);
        });
        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create a worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Callback Report");

        // Generate blob data for the workbook
        const blobData = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Convert the blob data to a Uint8Array
        const uint8Array = new Uint8Array(blobData);

        // Create a blob with the appropriate type
        const excelBlob = new Blob([uint8Array], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a download link and trigger the download
        const url = window.URL.createObjectURL(excelBlob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "callback_report.xlsx"; // Specify the desired file name
        document.body.appendChild(a);
        a.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };


    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [showMenu, setShowMenu] = useState(false);

    // Filter options based on search term
    const filteredOptions = camplist.filter(option =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        setShowMenu(true);
        if (e.target.value == '') {
            setCampaign("")
        }
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setSearchTerm(option.name); // Show selected label in input
        setShowMenu(false); // Hide menu after selection
        setCampaign(option.id)

    };

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const handleBlur = () => {
        // Delay hiding menu to allow option selection
        setTimeout(() => setShowMenu(false), 150);
    };


    const initial_fbData = {
        id: "0",
        uid: props.call_id,
        agent_id: "",
        customer_id: "",
        answers: {},
        fbanswer: {},
        comment: "",
        folloup: new Date(),
        dnc: false,
    };

    const [callbackFb, setCallbackFb] = useState(initial_fbData)

    // Callback parrent data 
    const parrentData = async (eventId, agent_id) => {
        console.log(agent_id, "---------", eventId, "----------", fback)
        const controller = new AbortController();
        let post_fb_data = {
            calluid: eventId,
            agent_id: agent_id,
        };

        const response = await axiosPrivate.get(
            process.env.REACT_APP_API_URL + "/contactcentre/get_fb_data/",
            {
                signal: controller.signal,
                params: post_fb_data,
            }
        );
        let fb_data = response?.data?.fobj_data
        let customer_data = response?.data?.customer_data
        console.log("fobjdata --------->  : ", fb_data)
        setCallbackFb((prev) => {
            return {
                ...prev,
                id: fb_data.id,
                agent_id: fb_data.feedback_agent,
                customer_id: fb_data.campaign_customer,
                answers: fb_data.feedback_questions,
                fbanswer: fb_data.feedback_labels,
                comment: fb_data.comment,
                folloup: fb_data.follow_up_date,
                uid: fb_data.uid,
                dnc: customer_data?.dnc,
            };
        });

        console.log("feedback data --------->  :  ", callbackFb)
        setfback(true);
    }


    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-500 flex items-center justify-center">
                    <BarChart3 className="w-5 h-5 text-white" />
                </div>
                <h1 className="font-bold text-xl text-gray-900">Callback Report</h1>
            </div>

            <Popup
                open={fback}
                modal
                nested
                position="center center"
                contentStyle={{ width: "0px", marginTop: "-10px" }}
            >
                {(close) => (
                    <CallBackFeedback
                        setfback={setfback}
                        close={close}
                        callbackFb={callbackFb}
                    />
                )}
            </Popup>

            <div className="flex flex-col">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                    <div>
                        <label htmlFor="table-search" className="block text-sm font-semibold text-gray-700 mb-1.5">
                            Search for items
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-5 h-5 text-gray-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                        clipRule="evenodd"
                                    ></path>
                                </svg>
                            </div>
                            <input
                                type="text"
                                id="table-search"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full pl-10 p-2.5"
                                placeholder="Search for items"
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Select Campaign</label>
                        <div className="relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleInputChange}
                                onClick={toggleMenu}
                                onBlur={handleBlur}
                                placeholder="Select Campaign"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                            />

                            {showMenu && (
                                <ul
                                    className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10"
                                    onMouseDown={(e) => e.preventDefault()}
                                >
                                    {filteredOptions.map((option) => (
                                        <li
                                            key={option.value}
                                            onClick={() => handleOptionSelect(option)}
                                            className="cursor-pointer py-2 px-4 hover:bg-gray-200"
                                        >
                                            {option.name}
                                        </li>
                                    ))}
                                    {filteredOptions.length === 0 && (
                                        <li className="py-2 px-4 text-gray-500">No options found</li>
                                    )}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Select Call Status</label>
                        <select
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                            onChange={(e) => {
                                setStatus(e.target.value);
                            }}
                        >
                            <option value="all">Select Call Status</option>
                            <option value={"ANSWERED"}>Answered</option>
                            <option value={"NOANSWER"}>No Answered</option>
                            <option value={"BUSY"}>Busy</option>
                            <option value={"CANCEL"}>Cancel</option>
                            <option value={"NOT_APPLICABLE"}>Not Applicable</option>
                        </select>
                    </div>

                    {auth?.user_details?.type === "agent" && (
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Campaign Scope</label>
                            <select
                                value={showDescendants ? "true" : "false"}
                                onChange={(e) => setShowDescendants(e.target.value === "true")}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                            >
                                <option value="false">My Campaigns</option>
                                <option value="true">Subordinate Campaigns</option>
                            </select>
                        </div>
                    )}
                </div>

                <div className={auth?.user_details?.type === "agent" ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4" : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4"}>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">From</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-500"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                                </svg>
                            </div>
                            <input
                                name="start"
                                type="date"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full pl-10 p-2.5"
                                onChange={(e) => {
                                    setFromDate(e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">To</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-500"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                                </svg>
                            </div>
                            <input
                                name="end"
                                type="date"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full pl-10 p-2.5"
                                onChange={(e) => {
                                    setToDate(e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-transparent mb-1.5 select-none">Submit</label>
                        <button
                            className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold p-2.5 rounded-lg"
                            onClick={FetchData}
                        >
                            Submit
                        </button>
                    </div>
                </div>

                <div className="flex flex-wrap items-center gap-3 mb-4">
                    <div
                        className="flex items-center gap-2 bg-red-100 px-3 py-2 rounded-2xl cursor-pointer"
                        onClick={() => downloadSheet("PDF")}
                    >
                        <Pdf className="w-5 h-5" />
                        <span className="text-red-500 font-medium">PDF</span>
                    </div>
                    <div
                        className="flex items-center gap-2 bg-green-100 px-3 py-2 rounded-2xl cursor-pointer"
                        onClick={() => downloadSheet("EXCEL")}
                    >
                        <Excel className="w-5 h-5" />
                        <span className="text-green-500 font-medium">Excel</span>
                    </div>
                </div>

                <div className="py-2 inline-block min-w-full">
                    <div className={`overflow-x-auto ${ auth?.user_details?.type === "agent" ? "h-[57vh]" : "h-[63.9vh]" }`}>
                        <table className="w-full ml-[-4rem]">
                            <thead>
                                <tr className="text-[#9AA7B5] text-[17px] font-karla font-[500]">
                                    <td className="pl-[6.0rem] pr-[2.1rem] py-4 text-left">Sl-No</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Customer</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Agent</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Campaign</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Call Status</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Call Time</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Play/Pause</td>
                                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">Download</td>
                                </tr>
                            </thead>

                            <tbody>
                                {callBackReportData.map((campaign_obj, index) => (
                                    <tr
                                        className="border-b text-[16px] font-karla text-gray-900 whitespace-nowrap"
                                        key={index}
                                    >
                                        <td className="pl-[6.0rem] pr-[2.1rem] py-4">
                                            {index + 1 + (pagination?.current_page - 1) * pagination?.page_size}
                                        </td>
                                        <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">
                                            {campaign_obj.customer_name}
                                            <br />
                                            {campaign_obj.legbDestinationNumber}
                                            <br />
                                        </td>
                                        <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">
                                            {campaign_obj.agent_username}
                                            <br />
                                            {campaign_obj.legaDestinationName}
                                            <br />
                                        </td>
                                        <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">
                                            {campaign_obj.name}
                                        </td>

                                        <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left">
                                            <div className="flex justify-start gap-2">
                                                <div className="mt-[4px]">
                                                    <Outgoing
                                                        width={12}
                                                        height={12}
                                                        fill={`${campaign_obj.callStatus === "ANSWERED" ? "green" : "red"}`}
                                                    />
                                                </div>
                                                {campaign_obj.callStatus ? <p>{campaign_obj.callStatus}</p> : <p>NOT APPLICABLE</p>}
                                            </div>
                                        </td>

                                        <td className="pl-[1.1rem] pr-[0.1rem] py-4 text-left">
                                            {campaign_obj.legastarttime}
                                        </td>

                                        <td className="pl-[1.1rem] cursor-pointer pr-[0.1rem] py-4 text-left">
                                            {campaign_obj.callBackParentID && campaign_obj.callStatus === "ANSWERED" ? (
                                                <audio
                                                    id={campaign_obj.callBackParentIDcallBackParentID}
                                                    preload="true"
                                                    controls
                                                >
                                                    <source
                                                        key={campaign_obj.callBackParentID}
                                                        src={`${BASE_URL}/uploads/downloadedWaveFile/${campaign_obj.callBackParentID.replace(
                                                            ".gsm",
                                                            ".wav"
                                                        )}`}
                                                        type="audio/wav"
                                                    />
                                                </audio>
                                            ) : (
                                                <p>No audio</p>
                                            )}
                                        </td>
                                        <td className="pl-[2.1rem] cursor-pointer pr-[0.1rem] py-4 text-center">
                                            <svg
                                                width="25px"
                                                height="25px"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                onClick={() => {
                                                    DownloadRecord(
                                                        campaign_obj.callBackParentID,
                                                        campaign_obj.legastarttime,
                                                        index + 1
                                                    );
                                                }}
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M12 3C12.5523 3 13 3.44772 13 4V12.5858L15.2929 10.2929C15.6834 9.90237 16.3166 9.90237 16.7071 10.2929C17.0976 10.6834 17.0976 11.3166 16.7071 11.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L7.2929 11.7071C6.90238 11.3166 6.90238 10.6834 7.2929 10.2929C7.68342 9.90237 8.31659 9.90237 8.70711 10.2929L11 12.5858V4C11 3.44772 11.4477 3 12 3ZM4.00001 14C4.55229 14 5.00001 14.4477 5.00001 15C5.00001 15.9772 5.00485 16.3198 5.05765 16.5853C5.29437 17.7753 6.22466 18.7056 7.41474 18.9424C7.68018 18.9952 8.02276 19 9.00001 19H15C15.9772 19 16.3198 18.9952 16.5853 18.9424C17.7753 18.7056 18.7056 17.7753 18.9424 16.5853C18.9952 16.3198 19 15.9772 19 15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15C21 15.0392 21 15.0777 21 15.1157C21.0002 15.9334 21.0004 16.4906 20.9039 16.9755C20.5094 18.9589 18.9589 20.5094 16.9755 20.9039C16.4907 21.0004 15.9334 21.0002 15.1158 21C15.0778 21 15.0392 21 15 21H9.00001C8.96084 21 8.92225 21 8.88423 21C8.06664 21.0002 7.50935 21.0004 7.02456 20.9039C5.0411 20.5094 3.49061 18.9589 3.09608 16.9755C2.99965 16.4906 2.99978 15.9334 2.99999 15.1158C3 15.0777 3.00001 15.0392 3.00001 15C3.00001 14.4477 3.44772 14 4.00001 14Z"
                                                    fill="#0F1729"
                                                />
                                            </svg>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="p-8">
                    <Pagination
                        pagination_data={pagination}
                        PaginationControl={PaginationControl}
                    />
                </div>
            </div>
        </div>
    );
}
export default CallBackReport;
